import type { IconNames } from "@/v2-ui/icon/icon.types"

/**
 * The issue codes api.Get_Lic_LicenseCoverage emits, with the name the
 * board shows and the icon. The message and the hint travel with the
 * issue; this is only what the client adds. An unknown code renders with
 * the generic entry so a new rule never shows blank.
 */
export const LICENSE_COVERAGE_ISSUE_META: Record<
  string,
  { label: string; iconSrc: IconNames }
> = {
  billing_gap: { label: "Billing gap", iconSrc: "calendar-xmark" },
  invoiced_not_covered: {
    label: "Invoiced, not covered",
    iconSrc: "file-invoice-dollar",
  },
  scheduled_overdue: { label: "Scheduled, not started", iconSrc: "clock" },
  trial_lapsed: { label: "Trial ran out", iconSrc: "hourglass-end" },
  convert_due: { label: "Convert the trial", iconSrc: "arrows-repeat" },
  not_live_knocking: {
    label: "Knocking without a license",
    iconSrc: "door-closed",
  },
}

export const LICENSE_COVERAGE_GENERIC_ISSUE_META = {
  label: "Needs a look",
  iconSrc: "triangle-warning" as IconNames,
}

/** The severities the proc emits (lic coverage issues). */
export const LICENSE_COVERAGE_SEVERITY_CRITICAL = 3
export const LICENSE_COVERAGE_SEVERITY_WARNING = 2
export const LICENSE_COVERAGE_SEVERITY_INFO = 1

/** The board's filter pills: what to show. */
export type LicenseCoverageFilter = "issues" | "critical" | "all"

export const LICENSE_COVERAGE_FILTER_OPTIONS: {
  value: LicenseCoverageFilter
  label: string
}[] = [
  { value: "issues", label: "With issues" },
  { value: "critical", label: "Critical only" },
  { value: "all", label: "Every license" },
]

/** The timeline's window around today, in months. */
export const LICENSE_COVERAGE_MONTHS_BACK = 12
export const LICENSE_COVERAGE_MONTHS_FORWARD = 12

export const LICENSE_COVERAGE_TOOLTIP =
  "Every license laid out on a timeline: the Fenerum subscriptions behind it " +
  "(as mirrored, hourly), the operator's own trial or grant, and the invoice " +
  "lines paying for it. The issues are where those do not add up — a hole " +
  "between one subscription ending and the next starting, an invoice " +
  "covering today with nothing live under it, a trial that ran out, a " +
  "convert that is due. Access itself is automated from billing; this is " +
  "where a human slip in Fenerum or HubSpot becomes visible, with the manual " +
  "override next to it."
